import { connect } from 'react-redux';
import SubheaderPanel from './subheader-panel';
import { setMode, setProductionPlaceOrderFilter, setOrderSpotFilter } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  selectableDurations: state.orders.selectableDurations,
  selectedModeId: state.orders.selectedMode,
  ordersStartDate: state.orders.ordersStartDate,
  localSettings: state.app.localSettings,
  routestops: state.orders.routestops,
  ordersProductionPlace: state.orders.ordersProductionPlace,
  preOrderDaysAheadAllowed: state.app.options.preOrderDaysAheadAllowed || 0,
  productionPlaces: state.menu.productionPlaces,
  spots: state.orders.orders,
  orderSpot: state.orders.orderSpot,
});

const mapDispatchToProps = dispatch => ({
  setProductionPlaceOrderFilter: ordersProductionPlace => dispatch(setProductionPlaceOrderFilter(ordersProductionPlace)),
  setOrderSpotFilter: orderSpot => dispatch(setOrderSpotFilter(orderSpot)),
  setMode: (modeid, startdate, enddate, options) => dispatch(setMode({ modeid, startdate, enddate, options })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubheaderPanel);
